import * as React from 'react';

// HORO-10360: birth-chart wheel glyph for the sidebar row — outer ring, inner
// ring and twelve spokes, white stroke to match the rest of the menu icons.
const BirthChartIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
        <circle cx={10} cy={10} r={7.6} stroke="#FFFFFF" strokeWidth={1.3} />
        <circle cx={10} cy={10} r={3.7} stroke="#FFFFFF" strokeWidth={1.3} />
        <path
            stroke="#FFFFFF"
            strokeWidth={1.3}
            strokeLinecap="round"
            d="M10 2.4v3.9M10 13.7v3.9M2.4 10h3.9M13.7 10h3.9M4.6 4.6l2.7 2.7M12.7 12.7l2.7 2.7M15.4 4.6l-2.7 2.7M7.3 12.7l-2.7 2.7"
        />
    </svg>
);

export default BirthChartIcon;
